import { useMemo } from "react";
import { TripperData } from "../../types";
import {
  useAtlasMode,
  useTripperWidgetContext,
} from "../../context/TripperWidgetContext";
import {
  getBusinessTypeLabel,
  getBusinessTypesInItinerary,
  isBusinessTypeFilterActive,
  toggleBusinessTypeFilterSelection,
} from "../../utils/businessTypeFilters";

type TripperBusinessTypeFiltersProps = {
  data: TripperData;
};

export const TripperBusinessTypeFilters = ({ data }: TripperBusinessTypeFiltersProps) => {
  const atlasMode = useAtlasMode();
  const {
    businessTypeFiltersEnabled,
    businessTypeFilterSelection,
    setBusinessTypeFilterSelection,
  } = useTripperWidgetContext();

  const availableTypes = useMemo(
    () => getBusinessTypesInItinerary(data.segments, data.operatorByEntityId),
    [data.segments, data.operatorByEntityId],
  );

  if (!atlasMode || !businessTypeFiltersEnabled || availableTypes.length === 0) {
    return null;
  }

  const handleToggle = (type: string | "all") => {
    setBusinessTypeFilterSelection(
      toggleBusinessTypeFilterSelection(businessTypeFilterSelection, type),
    );
  };

  return (
    <div className="tripper-business-type-filters" role="group" aria-label="Filter by business type">
      <div className="tripper-business-type-filters__row">
        <button
          type="button"
          className={`tripper-filter-chip${isBusinessTypeFilterActive(businessTypeFilterSelection, "all") ? " tripper-filter-chip--selected" : ""}`}
          aria-pressed={isBusinessTypeFilterActive(businessTypeFilterSelection, "all")}
          onClick={() => handleToggle("all")}
        >
          All
        </button>
        {availableTypes.map(type => (
          <button
            key={type}
            type="button"
            className={`tripper-filter-chip${isBusinessTypeFilterActive(businessTypeFilterSelection, type) ? " tripper-filter-chip--selected" : ""}`}
            aria-pressed={isBusinessTypeFilterActive(businessTypeFilterSelection, type)}
            onClick={() => handleToggle(type)}
          >
            {getBusinessTypeLabel(type)}
          </button>
        ))}
      </div>
    </div>
  );
};
